import {Injectable} from '@angular/core';
import {defaultAppConfig, defaultMapConfig, mergeDeep} from '../helpers';
import {AppConfig, MapConfig} from '../models/config.model';
import {forkJoin} from "rxjs";
import {HttpClient, HttpXhrBackend} from "@angular/common/http";

@Injectable({
  providedIn: 'platform'
})
export class ConfigService {
  static config: AppConfig = defaultAppConfig();
  static mapConfig: MapConfig = defaultMapConfig();

  constructor(protected httpClient: HttpClient) {
  }

  static loadConfig(): Promise<void> {
    return new Promise((resolve, reject) => {

      const configs = [
        {
          func: ConfigService.getDataFromUrl('./assets/config.json'),
          default: defaultAppConfig(),
          key: 'config'
        },
        {
          func: ConfigService.getDataFromUrl('./assets/map-data-config.json'),
          default: defaultMapConfig(),
          key: 'mapConfig'
        },
      ];

      const requestObservers = [];
      for (let cf of configs) {
        requestObservers.push(cf.func);
      }

      forkJoin(requestObservers).subscribe((results: any) => {
          for (const [index, value] of results.entries()) {
            try {
              ConfigService[configs[index].key] = mergeDeep(configs[index].default, value);
            } catch (e) {
              reject(e);
            }
          }
          resolve();
        },
        (error => {
          reject(error);
        })
      );
    });
  }

  static getDataFromUrl(url){
    const httpClient = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
    return httpClient.get(url);
  }

  static get(key: string, defaultValue: any = null, from: string = 'config'): any {
    let value = defaultValue;
    if (ConfigService[from]
      && ConfigService[from].hasOwnProperty(key)
      && ConfigService[from][key] !== null) {
      value = ConfigService[from][key];
    }
    return value;
  }

  static getAppConfig(): AppConfig {
    return ConfigService.config;
  }

  static getMapConfig(): MapConfig {
    return ConfigService.mapConfig;
  }

  static isProduction(): boolean {
    return ConfigService.get('production');
  }
}
